export enum CoverState {
    Hidden,
    Loading,
    Visible,
}
